<template>
  <p class="clearfix mb-0">
    <span class="float-md-left  d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://peoployed.com/tr"
        target="_blank"
      >Peoployed</b-link>
      <span class="d-none d-sm-inline-block">, Tüm hakları saklıdır.</span>
    </span>

    <span class="float-md-right d-none d-md-block">
  
    </span>
  </p>
</template>



<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
